'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var HEADER_SECTION_CLASS = 'StreamlineCmsSection--header';
var STICKY_CONTENT_CLASS = 'CMS-StickyHeader-content';
var STICKY_PLACEHOLDER_CLASS = 'CMS-StickyHeader-placeholder';

var isFixed = false;
var previousScrollPosition = 0;

var setHiddenHeader = function setHiddenHeader(elements, scrollPosition) {
	if (elements.header.offsetHeight > scrollPosition) {
		return;
	}

	elements.content.style.opacity = 0;
};

var setFixedHeader = function setFixedHeader(elements, scrollPosition, el) {
	if (isFixed) {
		return;
	}

	isFixed = true;

	var headerPosition = elements.header.getBoundingClientRect().top + scrollPosition;

	elements.content.style.top = headerPosition + 'px';
	elements.content.style.position = 'fixed';

	elements.placeholder.style.height = elements.content.offsetHeight + 'px';
	elements.placeholder.style.display = 'block';

	el.classList.add('CMS-StickyHeader--isSticky');
};

var resetHiddenHeader = function resetHiddenHeader(elements) {
	elements.content.style.opacity = null;
};

var resetFixedHeader = function resetFixedHeader(elements, el) {
	if (!isFixed) {
		return;
	}

	isFixed = false;

	resetHiddenHeader(elements);

	elements.content.style.top = null;
	elements.content.style.position = 'relative';

	elements.placeholder.style.height = null;
	elements.placeholder.style.display = 'none';

	el.classList.remove('CMS-StickyHeader--isSticky');
};

var onScroll = function onScroll(_ref, el, setState, elements) {
	var props = _ref.props;
	return function () {
		var scrollPosition = window.scrollY || window.pageYOffset;

		if (scrollPosition > elements.header.offsetHeight - elements.content.offsetHeight) {
			setFixedHeader(elements, scrollPosition, el);
		} else {
			resetFixedHeader(elements, el);
		}

		if (props.hideOnScroll) {
			if (scrollPosition > previousScrollPosition) {
				setHiddenHeader(elements, scrollPosition);
			} else {
				resetHiddenHeader(elements);
			}

			previousScrollPosition = scrollPosition;
		}
	};
};

var afterMount = function afterMount(component, el, setState) {
	var elements = {
		content: el.querySelector('.' + STICKY_CONTENT_CLASS),
		header: document.querySelector('.' + HEADER_SECTION_CLASS),
		placeholder: el.querySelector('.' + STICKY_PLACEHOLDER_CLASS)
	};

	onScroll(component, el, setState, elements);

	window.addEventListener('scroll', onScroll(component, el, setState, elements));
	window.addEventListener('resize', (0, _debounce2.default)(onScroll(component, el, setState, elements), 50));
};

var shouldUpdate = function shouldUpdate(_ref2, nextProps) {
	var props = _ref2.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref3) {
	var props = _ref3.props;

	var contentStyle = {
		position: 'relative',
		width: '100%',
		transition: 'opacity .2s linear',
		zIndex: 10
	};

	var placeholderStyle = {
		display: 'none',
		opacity: 0
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-StickyHeader', props.styleClasses.Sticky_Header], 'data-style-attr': 'Sticky_Header' },
		(0, _magicVirtualElement2.default)('div', { 'class': [STICKY_PLACEHOLDER_CLASS, props.styleClasses.Placeholder], style: placeholderStyle, 'data-style-attr': 'Placeholder' }),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': [STICKY_CONTENT_CLASS, props.styleClasses.Content], style: contentStyle, 'data-style-attr': 'Content' },
			props.children
		)
	), props);
};

exports.default = { afterMount: afterMount, name: 'cms-component-sticky-header', render: render, shouldUpdate: shouldUpdate };